import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EIconSize } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

export const GamblingMessageCa = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="gamblingMessageCa">
      <div className="attention">
        <GlobalIcon
          lib="generic"
          name="attentionGeneric"
          theme="colored"
          size={EIconSize._42}
          className="accounts_attentionImg"
        />
        <div>
          <div className="account_attention">
            {t('account.attentionMessageCa')}
          </div>
          <div className="gamblingMessageCa_account">
            {t('account.gamblingMessageCa')}
            <span
              className="span_account"
              dangerouslySetInnerHTML={{
                __html: t('account.playResponsibly', {
                  RESPONSIBLE_GAMING_URL: SpringConfigs.RESPONSIBLE_GAMING_URL
                })
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
